import { Component, OnInit, Input } from '@angular/core';
import { KeyValueService } from '../key-value-service/key-value.service';

@Component({
  selector: 'app-key-value-table',
  templateUrl: './key-value-table.component.html',
  styleUrls: ['./key-value-table.component.scss']
})
export class KeyValueTableComponent implements OnInit {

  @Input() items;

  constructor(private keyvalueService: KeyValueService) {
  }

  ngOnInit() {
  }

  public delete(i) {
    this.keyvalueService.deleteItem(i);
  }
}
